import { render, staticRenderFns } from "./AccionesModalEdicion.vue?vue&type=template&id=381efdd6&scoped=true&"
import script from "./AccionesModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./AccionesModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./AccionesModalEdicion.vue?vue&type=style&index=0&id=381efdd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381efdd6",
  null
  
)

export default component.exports